import React from 'react';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import '../styles/Projects.css';



const Projects = () => {
  return (
    <div id='projects'>
      <marquee><h1>Some of my Projects</h1></marquee>
      <a href="https://github.com/chetna050699/ecommerce_Reactjs">E commerce Project</a><p>Tech Stack Used :Reactjs,Javascript.</p><br></br>
      <a href="https://github.com/chetna050699/javascript_Game">Matching Javascript Game</a><p>Tech Stack Used: Javascript, Data Structures and Algorithms.</p><br></br>
      <a href="https://github.com/chetna050699/Dunzo">Dunzo React Clone</a><p>Tech Stack Used: Reactjs.</p><br></br>
      <a href="https://github.com/chetna050699/React_app_Cart">React app cart</a><p>Tech Stack Used: Reactjs, Javascript.</p><br></br>
      <a href="https://github.com/chetna050699/Modal_Sidebar_Reactjs">Modal Sidebar Reactjs</a><p>Tech Stack Used: Nodejs, Expressjs, Mongodb.</p><br></br>
      <a href="https://github.com/chetna050699/guesstheword">GUESS THE WORD</a><p>Tech Stack Used: Javascript</p><br></br>
      <a href="https://github.com/chetna050699/cssFlexboxproject">Grand Hotel's</a><p>Tech Stack Used: CSS3, Bootstrap, JQuery.</p><br></br>
      <marquee><h1>License and Certification's</h1></marquee>
      
      <a href="https://www.credly.com/badges/dbfc407a-dde3-4278-9653-0b3a2975e5d5/linked_in?t=rxy45s">Columbia School Of Engineering - Software Development</a><p></p><br></br>
      <a href="https://www.credly.com/badges/ff5df121-f074-488b-bead-669f9e00ce66/linked_in">Wiley Edge Alumni-Software Developer </a><p></p><br></br>
    </div>
    
  )
}

export default Projects
